module.exports = __webpack_public_path__ + "img/icon-energy-light-socket.04f9c17f.svg";